// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/catalog_items_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogItemsDatatable } from "./constants";
import type { AppsCatalogItemsDatatableParams, AppsCatalogItemsDatatableResult } from "./types";

export const getDataTableAppsCatalogItemsDatatable = reactQueryTableFetcherAdapter(
  appsCatalogItemsDatatable,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, catalogId }: AppsCatalogItemsDatatableParams
  ): Promise<AppsCatalogItemsDatatableResult> => {
    return fetch(
      "/apps/catalog_items_datatable",
      "GET",
      {
        groupby,
        query: serializeQueryObjects(query),
        limit,
        start,
        app_group_id: appGroupId,
        catalog_id: catalogId,
      },
      { signal }
    );
  }
);
